const pieChart = {
  categoriesContrats: ['#FFDD00', '#EC6608', '#FF812B', '#969A27', '#669D24', '#DBBD00', '#00713C', '#E4E5D2']
  // 1 Aucun => JAUNE CLAIR #FFDD00
  // 2 Tavail à façon (Echanges Céréales Aliments) => ORANGE AGRIAL #EC6608
  // 3 Echanges céréales semences => ORANGE CLAIR #FF812B
  // 4 Prix période => BRANCHE (VERT CLAIR) #969A27
  // 5 Contrat filière => VERT MOYEN #669D24
  // 6 Prix campagne => JAUNE #DBBD00
  // 7 Prix ferme =>  PRIMRAY (VERT FONCE) #00713C
  // 8 Tréso moisson à fixer => KAKI CLAIR #E4E5D2
}
const barChart = {
  grapheCompositionQualite: {
    groupe: '#D7D8D6', // correspond au gris clair
    perso: '#DBBD00', // correspond au secondary
    grey: '#F1F2F5',
    prixCampagne: '#969A27'// correspond au gris
  }
}
const jaugeChart = {
  groupe: ['#455A64', '#546E7A', '#78909C', '#90A4AE'],
  perso: 'rgba(150, 154, 39)'
}

export default {
  pieChart,
  barChart,
  jaugeChart
}
